import { deleteRequest, get, post} from './_defaults/fetch.js';

export const getOffices = ({params, config}) => get('/offices', {params, ...config});
export const getOffice = (id, params, config) => get(`/offices/${id}`, {params, ...config});
export const createOffice = (body, config) => post('/offices', body, config);
export const updateOffice = (id, body, config) => post(`/offices/${id}`, body, config);
export const deleteOffice = (id, config) => deleteRequest(`/offices/${id}`, null, config);
export const addAreaToOffice = ({id, data, config}) => post(`/offices/${id}/areas`, data, config);

